import { Directive } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { unsubscribeMixin } from '@shared/mixin/unsubscribe.mixin';
import { BvsHaftpflichtFormModel } from '../../features/bvs-haftpflicht/models/form/bvs-haftpflicht-form.model';
import { BvsHaftpflichtUndKaskoFormModel } from '../../features/bvs-haftpflicht-kasko/models/form/bvs-haftpflicht-und-kasko-form.model';
import { BoatType } from '@backend/models';

@Directive()
export class BvsBaseComponent extends unsubscribeMixin() {

  setValidatorsBasedOnBoatType(form: FormGroup<BvsHaftpflichtFormModel> | FormGroup<BvsHaftpflichtUndKaskoFormModel>, boatType: BoatType): void {
    if (boatType === BoatType.SegelbootSegelyacht) {
      this.addSegelValidators(form);
      this.removeMotorValidators(form);
      this.removeMaxKnotValidators(form);
    } else if (boatType === BoatType.MotorbootMotoryacht) {
      this.addMotorValidators(form);
      this.addMaxKnotValidators(form);
      this.removeSegelValidators(form);
    }
  }

  private addSegelValidators(form: FormGroup<BvsHaftpflichtFormModel> | FormGroup<BvsHaftpflichtUndKaskoFormModel>): void {
    form.controls.bvsBoatInformation.controls.sailSurfaceInMetersSquared.addValidators(Validators.required);
    form.controls.bvsBoatInformation.controls.mastMaterial.addValidators(Validators.required);
  }

  private removeSegelValidators(form: FormGroup<BvsHaftpflichtFormModel> | FormGroup<BvsHaftpflichtUndKaskoFormModel>): void {
    form.controls.bvsBoatInformation.controls.sailSurfaceInMetersSquared.removeValidators(Validators.required);
    form.controls.bvsBoatInformation.controls.mastMaterial.removeValidators(Validators.required);

    form.controls.bvsBoatInformation.controls.sailSurfaceInMetersSquared.updateValueAndValidity();
    form.controls.bvsBoatInformation.controls.mastMaterial.updateValueAndValidity();
  }

  private addMotorValidators(form: FormGroup<BvsHaftpflichtFormModel> | FormGroup<BvsHaftpflichtUndKaskoFormModel>): void {
    form.controls.bvsBoatInformation.controls.engineHp.addValidators(Validators.required);
  }

  private removeMotorValidators(form: FormGroup<BvsHaftpflichtFormModel> | FormGroup<BvsHaftpflichtUndKaskoFormModel>): void {
    form.controls.bvsBoatInformation.controls.engineHp.removeValidators(Validators.required);
    form.controls.bvsBoatInformation.controls.boatConstructionType.removeValidators(Validators.required);

    form.controls.bvsBoatInformation.controls.engineHp.updateValueAndValidity();
    form.controls.bvsBoatInformation.controls.boatConstructionType.updateValueAndValidity();
  }

  private addMaxKnotValidators(form: FormGroup<BvsHaftpflichtFormModel> | FormGroup<BvsHaftpflichtUndKaskoFormModel>): void {
    form.controls.bvsBoatInformation.controls.maxKnotsOver40.addValidators([Validators.required, Validators.max(40)]);
  }

  private removeMaxKnotValidators(form: FormGroup<BvsHaftpflichtFormModel> | FormGroup<BvsHaftpflichtUndKaskoFormModel>): void {
    form.controls.bvsBoatInformation.controls.maxKnotsOver40.removeValidators(Validators.required);

    form.controls.bvsBoatInformation.controls.maxKnotsOver40.updateValueAndValidity();
  }
}
